import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ListadoTrabajoComponent } from "./ListadoTrabajoComponent";

export const InicioComponent = () => {
  return (
    <div className="home">
      <h1>
        Soy <strong>Michael Cuadros</strong>, egresado de la carrera de
        Ingeniería de Sistemas de Información por la Universidad Peruana de
        Ciencias Aplicadas (UPC). Durante mi formación, destaqué académicamente
        al pertenecer al décimo superior. Mi trayectoria académica refleja un
        compromiso inquebrantable con el crecimiento personal y la innovación
        constante.
      </h1>

      <h2 className="title">
        Como profesional en Ingeniería de Sistemas de Información, estoy
        comprometido con la mejora continua y la generación de valor a través de
        soluciones tecnológicas efectivas. Actualmente me desempeño en el sector
        IT aplicando mis conocimientos en desarrollo web, automatización de
        procesos y soporte de sistemas críticos. Si tienes un
        proyecto, iniciativa o colaboración en mente, no dudes en contactarme, estaré gustoso de apoyarte. <br />
        <br />
        <Link className="contact_buton" to="/contacto">
          Contacta conmigo
        </Link>
      </h2>

      <hr />
      <section className="lasts-works">
        <h2 className="heading">Algunos de mis proyectos</h2>
        <h3>
          Para obtener una visión más completa de mi trabajo, te invito a
          explorar mi <NavLink className="Portafolio-Click" to={"/portafolio"}>PORTAFOLIO</NavLink>{" "}
        </h3>

        <div className="InicioList">
          <ListadoTrabajoComponent limite={2} />
        </div>
      </section>
    </div>
  );
};
